import { Ability, AbilityBuilder } from '@casl/ability'
import { initialAbility } from './config'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
const userData = JSON.parse(localStorage.getItem('userData'))
const existingAbility = userData ? userData.ability : null

export default new Ability(existingAbility || initialAbility)

import { defineAbility } from '@casl/ability';

export function defineAbilitiesFor(role) {
  const { can, cannot, rules } = new AbilityBuilder();

  can('read','Dashboard')

  if (role){
    switch (role) {
      case 'root' :
        can('manage','all')
        // cannot('recharge','User')
        break;
      case 'super_admin' :
        can('manage','all')
        cannot('recharge','Client')
        break;
      case 'admin' :
        can('manage','all')
        can('read', 'Currency')
        cannot('edit','Currency')
        can('read', 'User')
        can('read', 'Client')
        cannot('create', 'Client')
        cannot('edit', 'Client')
        cannot('delete', 'Client')
        cannot('recharge','Client')
        cannot('read','Audit')
        break;
      case 'agent' :
        //TODO quit this when adding permission to routes
        can('read','all')
        can('read','Auth')
        can('read','ACL')

        cannot('read', 'Currency')
        can('read','User')
        can('readBalance','User')
        can('recharge','User')
        cannot('edit', 'User')
        cannot('delete', 'User')
        can('read','Client')
        cannot('read','ClientWallet')
        cannot('read','ClientOperations')
        cannot('read','Audit')
        break;
      case 'customer' :
        can('read','all')
        cannot('read', 'Currency')
        can('read','User')
        can('readBalance','User')
        can('read','Client')
        cannot('read','ClientWallet')
        cannot('read','ClientOperations')
        cannot('read','Audit')
        break;
      default:
        can('read','all')
    }
  } else {
    can('read','all')
  }

  return new Ability(rules);
};

// export default defineAbility((can, cannot) => {
//   const role = userData?.role?.toLowerCase()
//   if (role){
//     switch (role) {
//       case 'root' :
//         can('manage','all')
//         break;
//       case 'super_admin' :
//         can('manage','all')
//         cannot('recharge','client')
//         break;
//       case 'admin' :
//         can('manage','all')
//         cannot('recharge','client')
//         break;
//       case 'agent' :
//         alert('agent')
//         break;
//       case 'customer' :
//         alert('customer')
//         break;
//       default:
//         can('read','all')
//     }
//   } else {
//     can('read','all')
//   }
//
//
// });
